export default "__VITE_ASSET__DgNJzY18__"